import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { ToastModule } from 'primeng/toast';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { FluidModule } from 'primeng/fluid';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { AuthProfile } from '../../../shared/models/auth-profile.interface';
import { AuthProfileViewModel } from '../viewmodels/auth-profile.viewmodel';
import { AuthProfileService } from '../services/auth-profile.service';
import { ToastService } from 'src/app/toast/toast.service';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { SelectModule } from 'primeng/select';
import { AuthService } from 'src/app/auth/login/services/auth.service';

@Component({
  selector: 'app-auth-profile',
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    IconFieldModule,
    InputIconModule,
    AutoCompleteModule,
    SelectModule,
    FluidModule,
    TooltipModule,
    DialogModule,
    FormsModule,
    ReactiveFormsModule,
    ToastModule,
    ConfirmDialogModule
  ],
  providers: [ConfirmationService],
  templateUrl: './auth-profile.component.html',
  styleUrls: ['./auth-profile.component.scss']
})
export class AuthProfileComponent implements OnInit {
  private http = inject(HttpClient);
  private messageService = inject(ToastService);
  private confirmationService = inject(ConfirmationService);
  private fb = inject(FormBuilder);
  private authProfileService = inject(AuthProfileService);
  private authService = inject(AuthService);

  viewModel = new AuthProfileViewModel(
    this.fb,
    this.authProfileService,
    this.messageService,
    this.http,
    this.confirmationService,
    this.authService
  );

  async ngOnInit(): Promise<void> {
    await this.viewModel.init();
  }
}
